const actions = {
  CREATE_MENU: 'CREATE_MENU',
  CREATE_MENU_ENDED: 'CREATE_MENU_ENDED',
  CREATE_MENU_PRODUCT: 'CREATE_MENU_PRODUCT',
  CREATE_MENU_PRODUCT_ENDED: 'CREATE_MENU_PRODUCT_ENDED',
  CREATE_MENU_PRODUCT_CATEGORY: 'CREATE_MENU_PRODUCT_CATEGORY',
  CREATE_MENU_PRODUCT_CATEGORY_ENDED: 'CREATE_MENU_PRODUCT_CATEGORY_ENDED',
  SEARCH_MENUS: 'SEARCH_MENUS',
  SEARCH_MENUS_ENDED: 'SEARCH_MENUS_ENDED',
  SEARCH_MENU_PRODUCTS: 'SEARCH_MENU_PRODUCTS',
  SEARCH_MENU_PRODUCTS_ENDED: 'SEARCH_MENU_PRODUCTS_ENDED',
  SEARCH_MENU_PRODUCT_CATEGORIES: 'SEARCH_MENU_PRODUCT_CATEGORIES',
  SEARCH_MENU_PRODUCT_CATEGORIES_ENDED: 'SEARCH_MENU_PRODUCT_CATEGORIES_ENDED',
  FIND_MENU: 'FIND_MENU',
  FIND_MENU_ENDED: 'FIND_MENU_ENDED',
  FIND_MENU_PRODUCT: 'FIND_MENU_PRODUCT',
  FIND_MENU_PRODUCT_ENDED: 'FIND_MENU_PRODUCT_ENDED',
  FIND_MENU_PRODUCT_CATEGORIES: 'FIND_MENU_PRODUCT_CATEGORIES',
  FIND_MENU_PRODUCT_CATEGORIES_ENDED: 'FIND_MENU_PRODUCT_CATEGORIES_ENDED',
  UPDATE_MENU: 'UPDATE_MENU',
  UPDATE_MENU_ENDED: 'UPDATE_MENU_ENDED',
  UPDATE_MENU_PRODUCT: 'UPDATE_MENU_PRODUCT',
  UPDATE_MENU_PRODUCT_ENDED: 'UPDATE_MENU_PRODUCT_ENDED',
  UPDATE_MENU_PRODUCT_CATEGORY: 'UPDATE_MENU_PRODUCT_CATEGORY',
  UPDATE_MENU_PRODUCT_CATEGORY_ENDED: 'UPDATE_MENU_PRODUCT_CATEGORY_ENDED',
  UPDATE_MENU_PRODUCT_CATEGORIES: 'UPDATE_MENU_PRODUCT_CATEGORIES',
  UPDATE_MENU_PRODUCT_CATEGORIES_ENDED: 'UPDATE_MENU_PRODUCT_CATEGORIES_ENDED',
  DELETE_MENUS: 'DELETE_MENUS',
  DELETE_MENUS_ENDED: 'DELETE_MENUS_ENDED',
  DELETE_MENU_PRODUCTS: 'DELETE_MENU_PRODUCTS',
  DELETE_MENU_PRODUCTS_ENDED: 'DELETE_MENU_PRODUCTS_ENDED',
  DELETE_MENU_PRODUCT_CATEGORIES: 'DELETE_MENU_PRODUCT_CATEGORIES',
  DELETE_MENU_PRODUCT_CATEGORIES_ENDED: 'DELETE_MENU_PRODUCT_CATEGORIES_ENDED',
};

export default actions;
